import React, { useEffect, useRef } from 'react';
import './App.css';
import useSplashImage from '@hooks/SplashScreen/useSplashImage';
import InitiateRoutes from './InitiateRoutes';
import { clearStorageAfterScan } from '@data/localStorageSetter';
import { useStoreCartItems } from '@state/useStoreCartItems';
import { useStoreOutlet } from '@state/useStoreOutlet';
import { useStoreSettings } from '@state/useStoreSettings';
import { useStoreSiccMember } from '@state/useStoreSiccMember';
import LoginFailurePage from '@pages/LoginFailurePage';
import useHydration from '@hooks/useHydration';
import { useStoreAppColor } from '@state/useStoreAppColor';
import { useStoreCategory } from '@state/useStoreCategory';
import { useStoreViewBill } from '@state/useStoreViewBill';
import { useStoreSellTime } from '@state/useStoreSellTime';
import { useClientState } from '@state/useClientState';
import useClientAmplify from '@hooks/useClientAmplify';
import { useTokenCredentials } from '@state/useTokenCredentials';
import { getDB, replicationStoreLog, replicationMiniappReq } from '@/InitiateRxdb';

export const getSearchParam = window.location.href.split('?')[1];
function App() {
  ///TODO: deteksi pertama scan/reload
  //cek semua state hydrated
  //error ke page lain
  const [hydration, kode, checkHydrated] = useHydration();
  const check = Boolean(localStorage.getItem('reload_page'));

  const getSplashScreen = useSplashImage();
  const _refApp = useRef();

  const { clearCart } = useStoreCartItems((state) => ({
    clearCart: state.clearCart,
  }));
  const { clearSellTimeProducts, clearInvalidTImeProducts } = useStoreSellTime(
    (state) => ({
      clearSellTimeProducts: state.clearSellTimeProducts,
      clearInvalidTImeProducts: state.clearInvalidTImeProducts,
    }),
  );
  const { clearSetting } = useStoreSettings((state) => ({
    clearSetting: state.clearSetting,
  }));
  const { clearOutlet, getOutletId } = useStoreOutlet((state) => ({
    clearOutlet: state.clearOutlet,
    getOutletId: state.getOutletId,
  }));
  const { clearSiccMember } = useStoreSiccMember((state) => ({
    clearSiccMember: state.clearSiccMember,
  }));
  const { updateAppColor } = useStoreAppColor((state) => ({
    updateAppColor: state.updateAppColor,
  }));
  const { removeCategory, removeActiveSection } = useStoreCategory((state) => ({
    removeCategory: state.removeCategory,
    removeActiveSection: state.removeActiveSection,
  }));
  const { removeViewBillId, removeIsViewBill } = useStoreViewBill((state) => ({
    removeViewBillId: state.removeViewBillId,
    removeIsViewBill: state.removeIsViewBill,
  }));
  const { getClient, updateClient } = useClientState((state) => ({
    getClient: state.getClient,
    updateClient: state.updateClient,
  }));

  const [clientAmplify] = useClientAmplify();
  const { getTokenCredentials } = useTokenCredentials((state) => ({
    getTokenCredentials: state.getTokenCredentials,
  }));
  const isMiniAppFailurePage = window.location.pathname === '/miniapp-failure';
  useEffect(() => {
    if (getSearchParam) {
      if (!isMiniAppFailurePage) {
        clearStorageAfterScan();
        clearSetting();
      }
      clearCart();
      clearOutlet();
      clearSiccMember();
      getSplashScreen('splash');
      removeCategory();
      removeActiveSection();
      removeViewBillId();
      removeIsViewBill();
      clearSellTimeProducts();
      clearInvalidTImeProducts();

      const colorFromUrl = (parameter) => {
        return new URLSearchParams(window.location.href).get(parameter);
      };
      const constructColorApp = {
        primaryThemeColor: colorFromUrl('primary_theme') || '#FF8A37',
        secondaryThemeColor: colorFromUrl('secondary_theme') || '#FEEDE2',
        primaryFontColor: colorFromUrl('primary_text') || '#000000',
        secondaryFontColor: colorFromUrl('secondary_text') || '#ffffff',
        backgroundColor: colorFromUrl('background') || '#FFE7D7',
        backgroundProduct: '#FFFFFF',
        headerAccordion: '#FF911C',
        successAccordion: '#00AA13',
        addButton: '#00AA13',
        backgroundAccordion: '#FFFFFF',
      };
      updateAppColor(constructColorApp);
    }
  }, [getSearchParam]);

  useEffect(() => {
    console.log('check hydration reload-----', check);
    const checkDb = async () => {
      if (!getClient().graphql && getTokenCredentials() && getTokenCredentials().access_token) {
        const client = clientAmplify(getTokenCredentials().access_token)
        updateClient(client);
        const db = await getDB();
        replicationStoreLog(db, getOutletId(), getClient());
        replicationMiniappReq(db, getOutletId(), getClient());
      }
    };

    if (check) {
      checkDb();
      //check hydration
      checkHydrated();
    }

    window.onbeforeunload = function () {
      console.log('reload---------');
      localStorage.setItem('reload_page', true);
    };

    setTimeout(() => {
      localStorage.setItem('reload_page', false);
    }, 2000);
  }, [check]);

  return (
    <div className="App" ref={_refApp}>
      {hydration ? (
        <InitiateRoutes />
      ) : (
        <LoginFailurePage
          message={`Failed to read stored data (${kode})!`}
        />
      )}
      {/* kode setiap mewakili zustand state hydrate sendiri2 */}
    </div>
  );
}

export default App;
